import { t as r } from "./to-integer-or-infinity.js";
import { t } from "./to-string.js";
import { r as o } from "./require-object-coercible.js";
var i = RangeError,
  e = function e(_e) {
    var n = t(o(this)),
      s = "",
      a = r(_e);
    if (a < 0 || a == 1 / 0) throw i("Wrong number of repetitions");
    for (; a > 0; (a >>>= 1) && (n += n)) 1 & a && (s += n);
    return s;
  };
export { e as s };